import { USER_EVENTS } from '@shared/core/user-events'
import { isKalamaBrandingEnabled } from 'src/modules/brand/utils/kalama-branding'
import { isAccountOldEnoughForKalamaNotice } from 'src/modules/brand/utils/kalama-notice'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import type { AlertCampaign, AlertContext } from '../alerts.types'
import { isKalamaRenamedPopupShownInTab } from './kalama-renamed-modal.domain'

export const kalamaRenamedModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.KALAMA_RENAMED,
  priority: ALERT_CAMPAIGN_PRIORITIES.KALAMA_RENAMED,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.KALAMA_RENAMED],
  isEligible: isEligibleForKalamaRenamedModal,
}

function isEligibleForKalamaRenamedModal({ profile, userEvents }: AlertContext): boolean {
  if (!isKalamaBrandingEnabled() || profile === null) return false
  if (userEvents.has(USER_EVENTS.KALAMA_RENAMED_WEB_POPUP_SEEN)) return false
  if (isKalamaRenamedPopupShownInTab(profile.id)) return false

  return isAccountOldEnoughForKalamaNotice(profile.created_at, new Date())
}
